import 'normalize.css/normalize.css';
import 'open-sans-fontface/open-sans.css';

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from './locale'; // Internationalization
import vuetify from "./plugins/vuetify";
import screenServicePlugin from "./plugins/screenServicePlugin";
Vue.use(screenServicePlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App, {
    props: { token: process.env.VUE_APP_SP_ACCESS_TOKEN, email: window.location.port === ("" + 8080) ? "staff1@spfxsolution.com" : "truongthanhtung1194@gmail.com"}
  }),
}).$mount("#app");
